import { render, staticRenderFns } from "./AdminExportTargets.vue?vue&type=template&id=18b9054a&"
import script from "./AdminExportTargets.vue?vue&type=script&lang=js&"
export * from "./AdminExportTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports